import { useQuery } from '@tanstack/react-query';
import { PaginatedResponse } from 'common/types';

import { useRequest, type BasePartCardData } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

export type QuotesComponentListQueryParams = Record<string, any>;

export type QuotesComponentListData = {
  created: string;
  estimatedAnnualUsage?: number | null;
  estimator?: any;
  exportControlled: boolean;
  finishes: any[];
  id: number;
  internalQuotes: Array<{
    id: number;
    site: { id: number; businessName: string };
    quoteNumber: number;
    userCanAccess: boolean;
    quoteItemId?: number;
  }>;
  isAssembly: boolean;
  material: any;
  part: BasePartCardData;
  partNumber?: string;
  process?: any;
  quantities: any[];
  quoteItem: any;
  revision?: string;
  superquoteQuoteItemId?: number | null;
};

export type QuotesComponentListQueryKey = readonly [
  'quotes',
  'components',
  QuotesComponentListQueryParams,
];

export const getQuotesComponentListQueryKey = (
  query?: QuotesComponentListQueryParams,
): QuotesComponentListQueryKey => ['quotes', 'components', query];

export const useQuotesComponentList: QueryFunction<
  PaginatedResponse<QuotesComponentListData>,
  [],
  QuotesComponentListQueryKey,
  QuotesComponentListQueryParams
> = ({ requestOptions, queryOptions, query } = {}) => {
  const queryKey = getQuotesComponentListQueryKey(query);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request('/quotes/components', {
        init: {
          signal,
        },
        query,
        shouldConvertQueryKeysToSnakeCase: false,
      }),
  });
};
